import type { FC } from 'react';
import { memo, useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop: FC = () => {
    const { pathname, state } = useLocation();

    useEffect(() => {
        if (state?.preventScrollToTop) return;
        window.scrollTo(0, 0);
    }, [pathname, state]);

    return null;
};

export default memo(ScrollToTop);
